import { Injectable, Type } from '@angular/core';
import { Observable } from 'rxjs';
import { GetProjectsParams, TaskShortInfoCategory } from '../../providers';
import { Project, Task } from '@web-portal/domains/shared/domain-models';

@Injectable()
export abstract class ProjectsServiceStrategy<P = Project, T = Task> {
  abstract getProjectsForTeam(teamId: string): Observable<P[]>;
  abstract loadSelectedProject(): P | null;
  abstract createProjectDialog(component: Type<unknown>, strategy: unknown): void;
  abstract openRenameProjectDialog(component: Type<unknown>, strategy: unknown): void;
  abstract uploadSelectedProjectThumbnail(file: File): Observable<P>;
  abstract deleteSelectedProjectThumbnail(): Observable<P>;
  abstract saveSelectedProject(project: P): void;
  abstract getProjectById(projectId: string, params?: string | undefined): Observable<P>;
  abstract getProjects(params?: GetProjectsParams): Observable<P[]>;
  abstract getTasks(projectId: string, params?: unknown): Observable<T[]>;
  abstract getTasksShortInfo(projectId: string): Observable<TaskShortInfoCategory[]>;
}
